import { render, staticRenderFns } from "./InternationalChannel.vue?vue&type=template&id=5ec21db5&scoped=true"
import script from "./InternationalChannel.vue?vue&type=script&lang=js"
export * from "./InternationalChannel.vue?vue&type=script&lang=js"
import style0 from "./InternationalChannel.vue?vue&type=style&index=0&id=5ec21db5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec21db5",
  null
  
)

export default component.exports